<div
  class="table overflow-hidden h-100"
  *ngIf="loadingType === LoadingTypeEnum.TABLE"
>
  <div class="ph-item">
    <div class="ph-col-12">
      <div class="td-ph-picture">
        <div class="ph-picture empty"></div>
      </div>

      <div class="ph-row">
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
      </div>
      <div class="ph-row">
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
      </div>
      <div class="ph-row">
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
      </div>
      <div class="ph-row">
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
      </div>
      <div class="ph-row">
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
      </div>
      <div class="ph-row">
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
      </div>
      <div class="ph-row">
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
      </div>
    </div>
  </div>
</div>

<div
  class="filter overflow-hidden h-100"
  *ngIf="loadingType === LoadingTypeEnum.FILTER"
>
  <div class="ph-item">
    <div class="ph-col-12">
      <div class="td-ph-picture">
        <div class="ph-picture empty"></div>
      </div>

      <div class="ph-row justify-content-between">
        <div class="ph-col-2 big"></div>
        <div class="ph-col-6 empty big"></div>
        <div class="ph-col-2 big"></div>
      </div>
    </div>
  </div>
</div>

<div
  class="profile overflow-hidden h-100"
  *ngIf="loadingType === LoadingTypeEnum.PROFILE"
>
  <div class="ph-item">
    <div class="ph-col-12">
      <div class="ph-picture"></div>

      <div class="ph-row justify-content-between">
        <div class="ph-col-2"></div>
        <div class="ph-col-2 empty"></div>
        <div class="ph-col-6"></div>
      </div>
      <div class="ph-row justify-content-between">
        <div class="ph-col-12"></div>
      </div>
      <div class="ph-row justify-content-between">
        <div class="ph-col-6"></div>
        <div class="ph-col-2 empty"></div>
        <div class="ph-col-2"></div>
      </div>
      <div class="ph-row justify-content-between">
        <div class="ph-col-8"></div>
      </div>
    </div>
  </div>
</div>

<div
  class="info overflow-hidden h-100"
  *ngIf="loadingType === LoadingTypeEnum.INFO"
>
  <div class="ph-item h-100">
    <div class="ph-col-12">
      <div class="ph-row">
        <div class="ph-col-4 big"></div>
      </div>

      <div class="info-box m-t-20">
        <div class="ph-row">
          <div class="ph-col-2"></div>
        </div>
        <div class="ph-row">
          <div class="ph-col-12 big"></div>
        </div>
      </div>

      <div class="info-box" *ngFor="let i of numberToArray(repeat)">
        <div class="ph-row">
          <div class="ph-col-2"></div>
        </div>

        <div class="ph-row">
          <div class="ph-col-12 big"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="big-info overflow-hidden h-100"
  *ngIf="loadingType === LoadingTypeEnum.BIG_INFO"
>
  <div class="ph-item h-100">
    <div class="ph-col-12">
      <div class="ph-row">
        <div class="ph-col-2 big"></div>
      </div>

      <div class="info-box m-t-20">
        <div class="ph-row">
          <div class="ph-col-2"></div>
          <div class="ph-col-4 empty"></div>
          <div class="ph-col-2"></div>
        </div>
        <div class="ph-row">
          <div class="ph-col-4 big"></div>
          <div class="ph-col-2 empty big"></div>
          <div class="ph-col-4 big"></div>
        </div>
      </div>
      <div class="info-box m-t-20">
        <div class="ph-row">
          <div class="ph-col-2"></div>
          <div class="ph-col-4 empty"></div>
          <div class="ph-col-2"></div>
        </div>
        <div class="ph-row">
          <div class="ph-col-4 big"></div>
          <div class="ph-col-2 empty big"></div>
          <div class="ph-col-4 big"></div>
        </div>
      </div>
      <div class="info-box m-t-20">
        <div class="ph-row">
          <div class="ph-col-2"></div>
          <div class="ph-col-4 empty"></div>
          <div class="ph-col-2"></div>
        </div>
        <div class="ph-row">
          <div class="ph-col-4 big"></div>
          <div class="ph-col-2 empty big"></div>
          <div class="ph-col-4 big"></div>
        </div>
      </div>
      <div class="info-box m-t-20">
        <div class="ph-row">
          <div class="ph-col-2"></div>
          <div class="ph-col-4 empty"></div>
          <div class="ph-col-2"></div>
        </div>
        <div class="ph-row">
          <div class="ph-col-4 big"></div>
          <div class="ph-col-2 empty big"></div>
          <div class="ph-col-4 big"></div>
        </div>
      </div>
      <div class="info-box m-t-20">
        <div class="ph-row">
          <div class="ph-col-2"></div>
          <div class="ph-col-4 empty"></div>
          <div class="ph-col-2"></div>
        </div>
        <div class="ph-row">
          <div class="ph-col-4 big"></div>
          <div class="ph-col-2 empty big"></div>
          <div class="ph-col-4 big"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="chart overflow-hidden h-100"
  *ngIf="loadingType === LoadingTypeEnum.CHART"
>
  <div class="ph-item h-100">
    <div class="ph-col-12 fit-content">
      <div class="ph-row">
        <div class="ph-col-4 big"></div>
        <div class="ph-col-2 empty big"></div>
        <div class="ph-col-2 big"></div>
        <div class="ph-col-2 big"></div>
      </div>
    </div>
    <div class="left-side">
      <div class="ph-row h-100 w-100">
        <div class="section-chart">
          <div class="ph-col-2 h-1 big"></div>
          <div class="ph-col-2 h-3 big"></div>
          <div class="ph-col-2 h-2 big"></div>
        </div>
        <div class="section-chart">
          <div class="ph-col-2 h-1 big"></div>
          <div class="ph-col-2 h-1 big"></div>
          <div class="ph-col-2 h-3 big"></div>
        </div>
        <div class="section-chart">
          <div class="ph-col-2 h-3 big"></div>
          <div class="ph-col-2 h-2 big"></div>
          <div class="ph-col-2 h-2 big"></div>
        </div>
      </div>
    </div>
    <div class="right-side">
      <div class="ph-row">
        <div class="ph-col-4 big"></div>
      </div>
      <div class="ph-row">
        <div class="ph-col-8"></div>
      </div>
      <div class="ph-row">
        <div class="ph-col-12"></div>
      </div>
      <div class="ph-row">
        <div class="ph-col-8"></div>
      </div>
      <div class="ph-row">
        <div class="ph-col-6"></div>
      </div>
    </div>
  </div>
</div>

<div
  class="pie overflow-hidden h-100"
  *ngIf="loadingType === LoadingTypeEnum.PIE"
>
  <div class="ph-item">
    <div class="ph-col-12">
      <div class="d-flex justify-content-between ph-row">
        <div
          class="ph-picture circle d-flex justify-content-center align-items-center"
        >
          <div class="inner-circle"></div>
        </div>
        <div class="right-side">
          <div class="ph-row">
            <div class="ph-col-4 big"></div>
          </div>
          <div class="ph-row">
            <div class="ph-col-8"></div>
          </div>
          <div class="ph-row">
            <div class="ph-col-6"></div>
          </div>
          <div class="ph-row">
            <div class="ph-col-2"></div>
          </div>
          <div class="ph-row">
            <div class="ph-col-12"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="buttons overflow-hidden h-100"
  *ngIf="loadingType === LoadingTypeEnum.BUTTONS"
>
  <div class="ph-item">
    <div class="ph-col-12">
      <div class="ph-row">
        <div class="ph-col-2 big" *ngFor="let i of numberToArray(repeat)"></div>
      </div>
    </div>
  </div>
</div>

<div class="small_button" *ngIf="loadingType === LoadingTypeEnum.SMALL_BUTTON">
  <div class="ph-item">
    <div class="ph-col-12">
      <div class="ph-row">
        <div class="ph-col-2 big" *ngFor="let i of numberToArray(repeat)"></div>
      </div>
    </div>
  </div>
</div>

<div
  class="workflow-save-button overflow-hidden h-100"
  *ngIf="loadingType === LoadingTypeEnum.WORKFLOW_BUTTON"
>
  <div class="ph-item">
    <div class="ph-col-12">
      <div class="ph-row">
        <div class="ph-col-2 big" *ngFor="let i of numberToArray(repeat)"></div>
      </div>
    </div>
  </div>
</div>

<div
  class="full_button overflow-hidden h-100"
  *ngIf="loadingType === LoadingTypeEnum.FULL_BUTTON"
>
  <div class="ph-item">
    <div class="ph-col-12">
      <div class="ph-row">
        <div class="big" *ngFor="let i of numberToArray(repeat)"></div>
      </div>
    </div>
  </div>
</div>

<div
  class="info-buttons overflow-hidden h-100"
  *ngIf="loadingType === LoadingTypeEnum.INFO_BUTTONS"
>
  <div class="ph-item">
    <div class="ph-col-12">
      <div class="section">
        <div class="ph-row">
          <div class="ph-col-6 big"></div>
          <div class="ph-col-4 big"></div>
        </div>
        <div class="ph-row">
          <div class="ph-col-8 big"></div>
        </div>
      </div>
      <div class="section">
        <div class="ph-row">
          <div class="ph-col-8 big"></div>
        </div>
        <div class="ph-row">
          <div class="ph-col-6 big"></div>
        </div>
      </div>
      <div class="section">
        <div class="ph-row">
          <div class="ph-col-4 big"></div>
        </div>
        <div class="ph-row">
          <div class="ph-col-6 big"></div>
        </div>
      </div>
      <div class="section">
        <div class="ph-row">
          <div class="ph-col-4 big"></div>
        </div>
        <div class="ph-row">
          <div class="ph-col-8 big"></div>
        </div>
      </div>
      <div class="ph-row">
        <div class="ph-col-12 big ph-btn"></div>
      </div>
      <div class="ph-row">
        <div class="ph-col-12 big ph-btn"></div>
      </div>
      <div class="ph-row">
        <div class="ph-col-12 big ph-btn"></div>
      </div>
    </div>
  </div>
</div>

<div
  class="timeline overflow-hidden h-100"
  *ngIf="loadingType === LoadingTypeEnum.TIMELINE"
>
  <div class="ph-item">
    <div class="ph-col-12" *ngFor="let i of numberToArray(repeat)">
      <div class="ph-row">
        <div class="circle-section">
          <div class="ph-col-2 circle"></div>
          <div class="text">
            <div class="ph-col-2"></div>
            <div class="ph-col-4"></div>
          </div>
        </div>
        <div class="box-section">
          <div class="ph-col-2 box" *ngFor="let i of numberToArray(25)"></div>
        </div>
      </div>
      <div class="ph-row">
        <div class="circle-section">
          <div class="circle empty"></div>
          <div class="text">
            <div class="ph-col-2"></div>
            <div class="ph-col-4"></div>
          </div>
        </div>
        <div class="box-section">
          <div class="ph-col-2 box" *ngFor="let i of numberToArray(25)"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="input overflow-hidden h-100"
  *ngIf="loadingType === LoadingTypeEnum.INPUT"
>
  <div class="ph-item">
    <div class="ph-col-12" *ngFor="let i of numberToArray(repeat)">
      <div class="ph-row">
        <div class="ph-col-12 big"></div>
      </div>
    </div>
  </div>
</div>

<div class="info-icon" *ngIf="loadingType === LoadingTypeEnum.INFO_ICON">
  <div class="ph-item">
    <div class="ph-col-12" *ngFor="let i of numberToArray(repeat)">
      <div class="ph-row">
        <div class="ph-col-6"></div>
        <div class="ph-col-4 big"></div>
        <div class="ph-col-2 icon"></div>
      </div>
    </div>
  </div>
</div>

<div class="block" *ngIf="loadingType === LoadingTypeEnum.BLOCK">
  <div class="ph-item">
    <div class="ph-col-12" *ngFor="let i of numberToArray(repeat)">
      <div class="ph-picture"></div>
    </div>
  </div>
</div>
